import { ReportSectionIds, type ReportSectionId, type ReportSettings } from "@tasduvar/engine";

type SectionMap = Record<ReportSectionId, boolean>;
const on = (ids: ReportSectionId[]): SectionMap => Object.fromEntries(ReportSectionIds.map((id) => [id, ids.includes(id)])) as SectionMap;

/** Spec §8.1 tablosu. */
export const PRESETS: Record<"ozet" | "yeterli" | "detayli", SectionMap> = {
  ozet: on(["cover", "projectInfo", "inputs", "drawing", "coefficients", "stabilityTbdy", "stabilityClassic", "basePressure", "rcDesign", "warnings", "summary"]),
  // bearingEc8: sayfa yalnız duvarda EN 1998-5 Ek F yöntemi seçiliyse basılır (Report.tsx); eski JSON'larda anahtar yoksa false sayılır
  yeterli: on(["cover", "projectInfo", "inputs", "drawing", "forceDiagram", "seismicParams", "coefficients", "forces", "stabilityTbdy", "stabilityClassic", "basePressure", "bearingEc8", "joints", "rcDesign", "reinforcement", "quantities", "warnings", "summary", "references"]),
  detayli: on([...ReportSectionIds]),
};

export const PRESET_LABEL: Record<ReportSettings["preset"], string> = { ozet: "Özet", yeterli: "Yeterli", detayli: "Detaylı", ozel: "Özel" };

export function applyPreset(s: ReportSettings, p: keyof typeof PRESETS): ReportSettings {
  return { ...s, preset: p, sections: { ...PRESETS[p] } };
}

/** Eski dosyalarda bulunmayan (sonradan eklenen) bölüm anahtarları kıyasa girmez; raporda kapalı sayılırlar. */
export function detectPreset(sections: ReportSettings["sections"]): ReportSettings["preset"] {
  for (const k of ["ozet", "yeterli", "detayli"] as const) {
    if (ReportSectionIds.every((id) => sections[id] === undefined || sections[id] === PRESETS[k][id])) return k;
  }
  return "ozel";
}
